import React from 'react';

interface DetailFieldProps {
  label: string;
  value?: React.ReactNode;
  mono?: boolean;
  fallback?: string;
  className?: string;
}

export const DetailField: React.FC<DetailFieldProps> = ({
  label,
  value,
  mono = false,
  fallback = '-',
  className = '',
}) => {
  const displayValue = value ?? fallback;
  const valueClasses = mono ? 'text-sm text-gray-900 font-mono' : 'text-sm text-gray-900';

  return (
    <div className={className}>
      <div className="text-sm font-medium text-gray-500 mb-1">{label}</div>
      <div className={valueClasses}>{displayValue}</div>
    </div>
  );
};
